import { z } from "zod"

export enum BookingStepType {
  WASH = "WASH",
  PACKAGES = "PACKAGES",
  CUSTOM_SECTION = "CUSTOM_SECTION",
  DAMPER_SERVICE = "DAMPER_SERVICE",
}

export const BookingStepOrderSchema = z.object({
  id: z.guid(),
  stepType: z.nativeEnum(BookingStepType),
  displayOrder: z.number().min(0),
  enabled: z.boolean(),
  customSectionId: z.guid().nullable(),
  customName: z.string().nullable(),
  storeId: z.guid(),
})

export const CreateBookingStepOrderSchema = BookingStepOrderSchema.omit({
  id: true,
  storeId: true,
}).extend({
  enabled: z.boolean().default(true),
})

export const UpdateBookingStepOrderSchema = z.object({
  displayOrder: z.number().min(0).optional(),
  enabled: z.boolean().optional(),
  customName: z.string().nullable().optional(),
})

export type BookingStepOrder = z.infer<typeof BookingStepOrderSchema>
export type CreateBookingStepOrder = z.infer<
  typeof CreateBookingStepOrderSchema
>
export type UpdateBookingStepOrder = z.infer<
  typeof UpdateBookingStepOrderSchema
>
